import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { Empty, MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GrpcCommonService } from './common.service';

@Injectable()
export class SubstanceGrpcContractService extends GrpcCommonService<MainApi.SubstanceGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.SubstanceGrpcContractClient) {
    super();
  }

  getAll() {
    return from(this._GrpcContract.GetAll(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
